import { getFormulaImageUrl } from "@/utils/nutrition/getFormulaImageUrl";

interface FormulaCardProps {
  title: string;
  description: string;
  image: string;
  backgroundImage: string;
  isSubscribed?: boolean;
  'data-testid'?: string;
}

export const FormulaCard = ({
  title,
  description,
  image,
  backgroundImage,
  isSubscribed,
  'data-testid': testId,
}: FormulaCardProps) => {
  return (
    <div
      data-testid={testId}
      className="flex flex-col items-center text-center p-6 rounded"
      style={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <div className="w-40 h-40 mb-4">
        <img data-testid="formulaCard-image" src={getFormulaImageUrl(image)} alt={title} className="w-full h-full object-contain" />
      </div>
      <h3 data-testid="formulaCard-title" className="typography-h2 text-primary mb-2">
        {title}
      </h3>
      <p data-testid="formulaCard-description" className="typography-body text-secondary">
        {description}
      </p>
      {isSubscribed && (
        <span data-testid="formulaCard-subscribedBadge" className="typography-caption2 text-success mt-2">
          Subscribed
        </span>
      )}
    </div>
  );
};